module.exports = __webpack_public_path__ + "static/media/29ADMSPC35.803ddf44.jpg";